import { KendoGridConfig } from '../../../../_foundation/kendo/models/grid.models';

const coaGridConfig: KendoGridConfig = {
  defaultSort: [{ field: 'reference', dir: 'asc' }],
  columns:
    [
      {
        field: 'reference',
        title: 'COA Reference',
        filter: 'text',
        _width: 170
      },
      {
        field: 'locationAreaName',
        title: 'Location Area Name',
        filter: 'text',
        _width: 150
      },
      {
        field: 'locationsText',
        title: 'Locations',
        filter: 'text',
        _width: 150
      },
      {
        field: 'maxExpectedPreLoad',
        title: 'Max Expected Pre-load',
        filter: 'numeric',
        _width: 150
      },
      {
        field: 'expectedAirGap',
        title: 'Expected Air Gap',
        filter: 'numeric',
        _width: 150
      },
      {
        field: 'expectedElevatedWeight',
        title: 'Expected Elevated Weight',
        filter: 'numeric',
        _width: 150
      },
      {
        field: 'upperLimitExpectedPenetrations',
        title: 'Upper Limit Expected Penetrations',
        filter: 'numeric',
        _width: 150
      },
      {
        field: 'lowerLimitExpectedPenetrations',
        title: 'Lower Limit Expected Penetrations',
        filter: 'numeric',
        _width: 150
      },
      {
        field: 'expectedPenetrations',
        title: 'Expected Penetrations',
        filter: 'numeric',
        _width: 150
      },
    ]
};

export default coaGridConfig;



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-coa-grid/project-detail-coa-grid.config.ts